import React from 'react';
import Icon from '../../../components/AppIcon';

const RFQSummaryCards = ({ summaryData }) => {
  const cards = [
    {
      title: 'Total RFQs',
      value: summaryData?.totalRFQs || 0,
      icon: 'FileText',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      change: '+12%',
      changeType: 'positive'
    },
    {
      title: 'Pending Review',
      value: summaryData?.pendingReview || 0,
      icon: 'Clock',
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
      change: '+5%',
      changeType: 'positive'
    },
    {
      title: 'Quoted',
      value: summaryData?.quoted || 0,
      icon: 'CheckCircle',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      change: '+18%',
      changeType: 'positive'
    },
    {
      title: 'Conversion Rate',
      value: `${summaryData?.conversionRate || 0}%`,
      icon: 'TrendingUp',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
      change: '+3.2%',
      changeType: 'positive'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {cards?.map((card, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 hover:shadow-moderate transition-smooth">
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <p className="text-sm font-medium text-muted-foreground mb-1">{card?.title}</p>
              <p className="text-2xl font-bold text-foreground">{card?.value}</p>
              <div className="flex items-center mt-2">
                <span className={`text-xs font-medium ${
                  card?.changeType === 'positive' ? 'text-green-600' : 'text-red-600'
                }`}>
                  {card?.change}
                </span>
                <span className="text-xs text-muted-foreground ml-1">vs last month</span>
              </div>
            </div>
            <div className={`flex items-center justify-center w-12 h-12 rounded-lg ${card?.bgColor}`}>
              <Icon name={card?.icon} size={24} className={card?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RFQSummaryCards;